import React, { useEffect, useState } from "react";
import ResendIcon from "assets/svgIcons/ResendIcon";
import TimeIcon from "assets/svgIcons/TimeIcon";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { Heading,Container } from "pages/Fleet/Settings/SettingsStyled";
import { DatePickerWrapper } from "assets/css/globle";
import SearchIcon from "assets/icons/search-icon.png";
import moment from "moment";
import CheckIcon from "assets/svgIcons/CheckIconWithBoreder";
import RefreshIcon from "assets/svgIcons/RefreshIconWithBorder";
import CheckCircleIcon from "assets/svgIcons/CheckCircleWithBorder";
import ExclamationMarkIcon from "assets/svgIcons/ExclamationMarkIconWithBorder";
import RefreshBtnIcon from "assets/svgIcons/ResendIcon";
import DownloadIcon from "assets/svgIcons/DownloadDownArrowIcon";
import { exportToExcel } from "_helperFunctions/exportToExcel";
import { validateEmail } from "_helperFunctions/validateEmail";
import {
    ActionWrapper,
    SearchWrapper,
    ActionBtn,
    RefreshBtn,
    TableWrapper,
    DateRangePickerWrapper,
} from "../SearchHeader/SearchHeaderStyled";
import { AccordionStyled } from "assets/css/globle";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordianDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { Box, Stack } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TextField, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { Loader } from "commonComponents/Loader/Loader";
import { DataGrid } from "@mui/x-data-grid";
import { API_STATUSES } from "redux/_helpers/statuses";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import clsx from "clsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import { ClickAwayListener } from "@mui/base";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";

const ScorecardsTable = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        getScoreCardState,
        getEmailAddressesState,
        getScoreCardStatus,
        getEmailAddressesStatus,
        siteSettingsData,
    } = useSelector((state) => state?.commonReducers) || [];
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const [disabledButton, setDisabledButton] = useState(false);
    const [outsideClick, setOutsideClick] = useState(false);
    const [outsideClick1, setOutsideClick1] = useState(false);
    const [newScoreCards, setNewScoreCards] = useState("");
    const [rows, setRows] = useState();
    const [emailrows, setEmailRows] = useState();
    const [searched, setSearched] = useState("");
    const [isValid, setIsValid] = useState("");
    const [startDate, setStartDate] = useState(
        localStorage.getItem("scorecardStartDate")
            ? new Date(localStorage.getItem("scorecardStartDate"))
            : new Date()
    );
    const [endDate, setEndDate] = useState(
        localStorage.getItem("scorecardEndDate")
            ? new Date(localStorage.getItem("scorecardEndDate"))
            : new Date()
    );
    const [startEmailDate, setEmailStartDate] = useState(
        localStorage.getItem("emailStartDate")
            ? new Date(localStorage.getItem("emailStartDate"))
            : new Date()
    );
    const [endEmailDate, setEmailEndDate] = useState(
        localStorage.getItem("emailEndDate")
            ? new Date(localStorage.getItem("emailEndDate"))
            : new Date()
    );

    const [statusFilter, setStatusFilter] = useState([
        "Ready",
        "Success",
        "Retry",
        "Failed",
    ]);

    useEffect(() => {
        if (startDate > endDate) setEndDate(startDate);
    }, [startDate]);

    useEffect(() => {
        if (startDate > endDate) setStartDate(endDate);
    }, [endDate]);

    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem("statusFilter"));
        if (savedFilters) {
            setStatusFilter(savedFilters);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("statusFilter", JSON.stringify(statusFilter));
    }, [statusFilter]);

    useEffect(() => {
        if (
            startDate &&
            endDate &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0 &&
            siteId.get()
        ) {
            dispatch(
                COMMON_SERVICES.getScoreCardServices(
                    siteId.get(),
                    setDateToLocalMidnightUTC(startDate),
                    setDateToLocalMidnightUTC(endDate)
                )
            );
        }
        if (
            startEmailDate &&
            endEmailDate &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0 &&
            siteId.get()
        ) {
            dispatch(
                COMMON_SERVICES.getEmailAddressesServices(
                    siteId.get(),
                    setDateToLocalMidnightUTC(startEmailDate),
                    setDateToLocalMidnightUTC(endEmailDate)
                )
            );
        }
    }, [siteSettingsData, siteId.get()]);

    useEffect(() => {
        const record =
            getScoreCardState &&
            getScoreCardState?.length > 0 &&
            getScoreCardState?.map((val, i) => {
                return {
                    unixTime: moment(val?.RequestedUtc).unix(),
                    ...val,
                    id: i,
                    Id: val?.Id,
                    email: val?.Email,
                    player: val?.Players,
                    car: val?.CarNumber,
                    Status: val?.Status,
                    requested: val?.RequestedUtc,
                    gpsiCarId: val?.GpsiCarId,
                    received: val?.CreatedUtc,
                };
            });
        setRows(record);
        setNewScoreCards(record);
    }, [getScoreCardState]);
    useEffect(() => {
        const record =
            getEmailAddressesState &&
            getEmailAddressesState?.length > 0 &&
            getEmailAddressesState?.map((val, i) => {
                return {
                    ...val,
                    id: i,
                };
            });
        setEmailRows(record);
    }, [getEmailAddressesState]);
    useEffect(() => {
        if (statusFilter.length !== 4) {
            const statuscopy = [...statusFilter];
            const filterStatus =
                newScoreCards?.length > 0 &&
                newScoreCards?.filter((i) => statuscopy.includes(i.Status));
            setRows(filterStatus);
        }
    }, [newScoreCards, statusFilter]);

    function setDateToLocalForDisplay(dateToSet) {
        if (
            dateToSet !== null &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0
        ) {
            var tempDate = moment
                .utc(dateToSet)
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("DD-MMM-YYYY hh:mm a");

            return tempDate;
        } else {
            return null;
        }
    }

    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);
        let filteredRows = [];
        filteredRows = newScoreCards?.filter((row) => {
            return (
                row?.Players?.toLowerCase().includes(searchedVal?.toLowerCase()) ||
                row?.Email?.toLowerCase().includes(searchedVal?.toLowerCase())
            );
        });
        if (startDate && endDate) {
            handleOnStartDate(startDate, filteredRows);
            handleOnEndDate(endDate, filteredRows);
        } else {
            setRows(filteredRows);
        }
    };

    const handleFilter = (Status) => {
        const statuscopy = [...statusFilter];
        if (statuscopy.includes(Status)) {
            statuscopy.splice(statuscopy.indexOf(Status), 1);
            setStatusFilter(statuscopy);
        } else {
            statuscopy.push(Status);
            setStatusFilter(statuscopy);
        }
        const filterStatus =
            newScoreCards &&
            newScoreCards?.filter((i) => statuscopy.includes(i.Status));
        setRows(filterStatus);
    };

    const handleOnStartDate = (newValue, data) => {
        let selectedStartDate = moment(newValue).unix();
        if (selectedStartDate && endDate) {
            const updatedTime =
                data &&
                data?.length > 0 &&
                data?.filter(
                    (udt) =>
                        new Date(moment(udt?.RequestedUtc).format("YYYY-MMM-DD")) <=
                        new Date(moment(endDate).format("YYYY-MMM-DD")) &&
                        new Date(moment(udt?.RequestedUtc).format("YYYY-MMM-DD")) >=
                        new Date(moment(newValue).format("YYYY-MMM-DD"))
                );
            setRows(updatedTime);
        }
        setStartDate(newValue);
    };

    const handleOnEndDate = (newValue, data) => {
        let selectedEndDate = moment(newValue).unix();
        if (startDate && selectedEndDate) {
            const updatedTime =
                data &&
                data?.length > 0 &&
                data?.filter((udt) => {
                    return (
                        new Date(moment(udt?.RequestedUtc).format("YYYY-MMM-DD")) >=
                        new Date(moment(startDate).format("YYYY-MMM-DD")) &&
                        new Date(moment(udt?.RequestedUtc).format("YYYY-MMM-DD")) <=
                        new Date(moment(newValue).format("YYYY-MMM-DD"))
                    );
                });
            setRows(updatedTime);
        }
        setEndDate(newValue);
    };

    function setDateToLocalMidnightUTC(dateToSet) {
        if (dateToSet !== null && siteSettingsData) {
            var returnDate = moment();
            if (typeof dateToSet === "string") {
                dateToSet = moment(dateToSet);
                returnDate.utcOffset(-siteSettingsData.TimeZoneOffset);
                returnDate
                    .year(dateToSet.year())
                    .month(dateToSet.month())
                    .date(dateToSet.date())
                    .hours(0)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0);
                returnDate = returnDate.toISOString();

                return returnDate;
            } else {
                returnDate.utcOffset(-siteSettingsData.TimeZoneOffset);
                returnDate
                    .year(dateToSet.getFullYear())
                    .month(dateToSet.getMonth())
                    .date(dateToSet.getDate())
                    .hours(0)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0);
                returnDate = returnDate.toISOString();

                return returnDate;
            }
        } else {
            return null;
        }
    }

    const refreshUI = () => {
        dispatch(
            COMMON_SERVICES.getScoreCardServices(
                siteId.get(),
                setDateToLocalMidnightUTC(startDate),
                setDateToLocalMidnightUTC(endDate)
            )
        );
    };
    const refreshEmailUI = () => {
        dispatch(
            COMMON_SERVICES.getEmailAddressesServices(
                siteId.get(),
                setDateToLocalMidnightUTC(startEmailDate),
                setDateToLocalMidnightUTC(endEmailDate)
            )
        );
    };
    const downloadToExcel = () => {
        let SiteName =
            siteSettingsData &&
            siteSettingsData !== undefined &&
            siteSettingsData?.Name;
        let headerData = [];
        headerData.push([t("Site"), SiteName]);
        headerData.push([t("Start_Date"), startEmailDate.toLocaleDateString()]);
        headerData.push([t("End_Date"), endEmailDate.toLocaleDateString()]);
        let emailData = [];
        getEmailAddressesState?.map(val =>
            emailData.push({
                [t("Email_Addresses")]: val?.Email,
                [t("Received")]: setDateToLocalForDisplay(val?.CreatedUtc)
            })
        );
        exportToExcel(headerData, emailData, t("Email_Addresses") + "_" + SiteName + "_" +
            new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }));
    };

    const resendEmail = (id, email) => {
        dispatch(COMMON_SERVICES?.putResendEmailServices(id, siteId.get(), email));
        dispatch(
            COMMON_SERVICES.getScoreCardServices(
                siteId.get(),
                setDateToLocalMidnightUTC(startDate),
                setDateToLocalMidnightUTC(endDate)
            )
        );
    };
    const handleEdit = (params) => {
        if (params?.row?.Email.trim() !== params?.value.trim()) {
            if (validateEmail(params?.value)) {
                resendEmail(params?.row.Id, params?.value);
                dispatch(
                    COMMON_SERVICES.getScoreCardServices(
                        siteId.get(),
                        setDateToLocalMidnightUTC(startDate),
                        setDateToLocalMidnightUTC(endDate)
                    )
                );
            }
            else {
                setIsValid(<p style={{ color: "red" }}>{t("Email_is_not_valid")}</p>);
            }
        }
    }
    const columns = [
        {
            field: "email",
            headerName: t("Email"),
            flex: 3,
            headerClassName: "lastcolumnSeparator",
            cellClassName: "super-app-theme--cell",
            headerAlign: "center",
            justifyContent: "center",
            editable: true,
            renderCell: (params) => {
                return (
                    <Tooltip arrow open={isValid !== ""} title={params?.row?.Email.trim() !== params?.value.trim() ? isValid : ""}>

                        <div><Tooltip arrow title={t("Double_Click_Email")}><span>{params?.row?.Email}</span></Tooltip>

                        </div>
                    </Tooltip>

                );
            },
        },
        {
            field: "gpsiCarId",
            headerName: t("GPSI_ID"),
            flex: 3,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            justifyContent: "center",
        },
        {
            field: "received",
            headerName: t("Received"),
            flex: 3,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            justifyContent: "center",
            renderCell: (params) => {
                return (
                    <div className="super-time-theme--cell">
                        <TimeIcon />
                        <span>{setDateToLocalForDisplay(params?.row?.received)}</span>
                    </div>
                );
            },
        },

        {
            field: "player",
            headerName: t("Player"),
            flex: 2,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
        },
        {
            field: "car",
            headerName: t("Cars"),
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
        },

        {
            field: "requested",
            headerName: t("Requested"),
            align: "center",
            flex: 2,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <div className="super-time-theme--cell">
                        <TimeIcon />
                        <span>{setDateToLocalForDisplay(params?.row?.requested)}</span>
                    </div>
                );
            },
        },
        {
            field: "Status",
            headerName: t("Status"),
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            cellClassName: (params) => {
                if (params.value == null) {
                    return "";
                }

                return clsx("super-app", {
                    negative: params.value === "Failed",
                    positive: params.value === "Success",
                    retry: params.value === "Retry",
                    ready: params.value === "Ready",
                });
            },
        },

        {
            field: "action",
            headerName: t("Action"),
            sortable: false,
            flex: 2,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <div className="action-btn">
                        <Tooltip title={t("Resend")}>
                            <button
                                className="round-btn"
                                onClick={() => resendEmail(params?.row.Id, params.row?.Email)}
                            >
                                <ResendIcon />
                            </button>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];
    const emailColumns = [
        {
            field: "Email",
            headerName: t("Email_Addresses"),
            flex: 3,
            headerClassName: "lastcolumnSeparator",
            cellClassName: "super-app-theme--cell",
            headerAlign: "center",
            justifyContent: "center",
        },
        {
            field: "CreatedUtc",
            headerName: t("Received"),
            flex: 3,
            headerClassName: "lastcolumnSeparator",
            headerAlign: "center",
            justifyContent: "center",
            renderCell: (params) => {
                return (
                    <div className="super-time-theme--cell">
                        <TimeIcon />
                        <span>{setDateToLocalForDisplay(params?.row?.CreatedUtc)}</span>
                    </div>
                );
            },
        }
    ];
    const [expanded, setExpanded] = useState(true); // State to manage expansion

    const handleChange = () => {
        setExpanded(!expanded); // Toggle between true and false
    };
    return (
        <>
            <Container>
                <AccordionStyled>
                    <Accordion expanded={expanded} onChange={handleChange}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Heading>
                                <h3>{t("Daily_Play_Scorecards")}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordianDetails>
                            <ActionWrapper>
                                <div>
                                    <SearchWrapper>
                                        <input
                                            type="text"
                                            placeholder={t("Search_by_Player_Name/Email")}
                                            value={searched}
                                            onChange={(e) => requestSearch(e.target.value)}
                                        />
                                        <img src={SearchIcon} alt="search-icon" />
                                    </SearchWrapper>
                                </div>

                                <div>
                                    <DatePickerWrapper>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateRangePickerWrapper>
                                                <p className="label">{t("Start")}</p>

                                                <ClickAwayListener
                                                    onClickAway={() => {
                                                        if (outsideClick) {
                                                            setStartDate(new Date(startDate));
                                                            setDisabledButton(false);
                                                            setOutsideClick(false);
                                                        }
                                                    }}
                                                >
                                                    <DatePicker
                                                        inputFormat="DD-MMM-YYYY"
                                                        value={startDate}
                                                        className="test"
                                                        onChange={(newValue) => {
                                                            if (newValue && newValue.format() !== "Invalid Date") {
                                                                localStorage.setItem(
                                                                    "scorecardStartDate",
                                                                    new Date(newValue)
                                                                );
                                                                setStartDate(new Date(newValue));
                                                            } else {
                                                                if (
                                                                    newValue === null ||
                                                                    newValue.format() === "Invalid Date"
                                                                ) {
                                                                    setDisabledButton(true);
                                                                    setOutsideClick(true);
                                                                } else {
                                                                    setDisabledButton(true);
                                                                }
                                                            }
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                        PaperProps={{
                                                            sx: {
                                                                maxHeight: 350,
                                                                "& .MuiPickersLayout-contentWrapper": {
                                                                    mb: 0,
                                                                }
                                                            }
                                                        }}
                                                        components={{
                                                            ActionBar: (props) => (
                                                                <TodayDateActionBar
                                                                    {...props}
                                                                    onToday={() => {
                                                                        const today = moment().startOf("day");

                                                                        if (today && today.format() !== "Invalid Date") {
                                                                            localStorage.setItem(
                                                                                "scorecardStartDate",
                                                                                new Date(today)
                                                                            );
                                                                            setStartDate(new Date(today));
                                                                            props.onAccept?.();
                                                                            props.onClose?.();
                                                                        } else {
                                                                            if (
                                                                                today === null ||
                                                                                today.format() === "Invalid Date"
                                                                            ) {
                                                                                setDisabledButton(true);
                                                                                setOutsideClick(true);
                                                                            } else {
                                                                                setDisabledButton(true);
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            ),
                                                        }}
                                                    />
                                                </ClickAwayListener>

                                                <p className="label">{t("End")}</p>
                                                <ClickAwayListener
                                                    onClickAway={() => {
                                                        if (outsideClick1) {
                                                            setEndDate(new Date(endDate));
                                                            setDisabledButton(false);
                                                            setOutsideClick1(false);
                                                        }
                                                    }}
                                                >
                                                    <DatePicker
                                                        className="test"
                                                        inputFormat="DD-MMM-YYYY"
                                                        value={endDate}
                                                        onChange={(newValue) => {
                                                            if (newValue && newValue.format() !== "Invalid Date") {
                                                                localStorage.setItem(
                                                                    "scorecardEndDate",
                                                                    new Date(newValue)
                                                                );
                                                                setEndDate(new Date(newValue));
                                                                setDisabledButton(false);
                                                            } else {
                                                                if (
                                                                    newValue === null ||
                                                                    newValue.format() === "Invalid Date"
                                                                ) {
                                                                    setDisabledButton(true);
                                                                    setOutsideClick1(true);
                                                                } else {
                                                                    setDisabledButton(true);
                                                                }
                                                            }
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                        PaperProps={{
                                                            sx: {
                                                                maxHeight: 350,
                                                                "& .MuiPickersLayout-contentWrapper": {
                                                                    mb: 0,
                                                                }
                                                            }
                                                        }}
                                                        components={{
                                                            ActionBar: (props) => (
                                                                <TodayDateActionBar
                                                                    onToday={() => {
                                                                        const today = moment().startOf("day");
                                                                        if (today && today.format() !== "Invalid Date") {
                                                                            localStorage.setItem(
                                                                                "scorecardEndDate",
                                                                                new Date(today)
                                                                            );
                                                                            setEndDate(new Date(today));
                                                                            setDisabledButton(false);
                                                                            props.onAccept?.();
                                                                            props.onClose?.();
                                                                        } else {
                                                                            if (
                                                                                today === null ||
                                                                                today.format() === "Invalid Date"
                                                                            ) {
                                                                                setDisabledButton(true);
                                                                                setOutsideClick1(true);
                                                                            } else {
                                                                                setDisabledButton(true);
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            ),
                                                        }}
                                                    />
                                                </ClickAwayListener>
                                            </DateRangePickerWrapper>
                                        </LocalizationProvider>
                                    </DatePickerWrapper>
                                </div>
                                <ActionBtn>
                                    <Tooltip title={t("Show_scorecards_with_Ready_Status")}>
                                        <div>
                                            <CheckIcon
                                                className="title"
                                                onClick={() => handleFilter("Ready")}
                                                color={
                                                    statusFilter.includes("Ready")
                                                        ? "var(--theme-background)"
                                                        : "none"
                                                }
                                            />
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={t("Show_scorecards_with_Retry_Status")}>
                                        <div>
                                            <RefreshIcon
                                                className="title"
                                                onClick={() => handleFilter("Retry")}
                                                color={
                                                    statusFilter.includes("Retry")
                                                        ? "var(--theme-background)"
                                                        : "none"
                                                }
                                                stroke="var(--filter-bar-btn-border)"
                                                fill="var(--filter-bar-btn-border)"
                                            />
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={t("Show_scorecards_with_Success_Status")}>
                                        <div>
                                            <CheckCircleIcon
                                                className="title"
                                                onClick={() => handleFilter("Success")}
                                                color={
                                                    statusFilter.includes("Success")
                                                        ? "var(--theme-background)"
                                                        : "none"
                                                }
                                                stroke="var(--filter-bar-btn-border)"
                                                fill="var(--filter-bar-btn-border)"
                                            />
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={t("Show_scorecards_with_Failed_Status")}>
                                        <div>
                                            <ExclamationMarkIcon
                                                className="title"
                                                onClick={() => handleFilter("Failed")}
                                                color={
                                                    statusFilter.includes("Failed")
                                                        ? "var(--theme-background)"
                                                        : "none"
                                                }
                                                stroke="var(--filter-bar-btn-border)"
                                                fill="var(--filter-bar-btn-border)"
                                            />
                                        </div>
                                    </Tooltip>
                                </ActionBtn>
                                <Tooltip title={t("Refresh")}>
                                    <div>
                                        <RefreshBtn disabled={disabledButton} onClick={refreshUI}>
                                            <RefreshBtnIcon color="var(--inner-section-bg)" />
                                            {t("Refresh")}
                                        </RefreshBtn>
                                    </div>
                                </Tooltip>

                            </ActionWrapper>
                        <TableWrapper className="no-pagination" style={{height: "calc(100vh - 288px)"}}>
                                {getScoreCardStatus && getScoreCardStatus === "success" ? (
                                    <Box
                                        sx={{
                                            width: "100%",
                                            textAlign: "center",
                                            height: "100%",

                                            "& .super-time-theme--cell": {
                                                fontWeight: "500",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                            },

                                            "& .super-app-theme--cell": {
                                                color: "var(--club-car-gold-bg)",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.negative": {
                                                color: "#FA3C30",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.positive": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.retry": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.ready": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                        }}
                                    >
                                    <DataGrid style={{maxHeight:"450px"}}
                                            components={{
                                                NoRowsOverlay: () => (
                                                    <Stack
                                                        height="100%"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        {t("No_data")}
                                                    </Stack>
                                                ),
                                            }}
                                            rows={rows ? rows : []}
                                            columns={columns}
                                            onCellEditCommit={handleEdit}
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            hideFooter
                                            getRowId={(row) => row.id}
                                            getRowHeight={() => 30}
                                        />
                                    </Box>
                                ) : (
                                    <CenteredLoader>
                                        <Loader />
                                    </CenteredLoader>
                                )}
                            </TableWrapper>
                        </AccordianDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Heading>
                                <h3>{"Email Addresses"}</h3>
                            </Heading>
                        </AccordionSummary>
                        <AccordianDetails>
                            <ActionWrapper>
                                <div>
                                    <DatePickerWrapper>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateRangePickerWrapper>
                                                <p className="label">{t("Start")}</p>

                                                <ClickAwayListener
                                                    onClickAway={() => {
                                                        if (outsideClick) {
                                                            setStartDate(new Date(startDate));
                                                            setDisabledButton(false);
                                                            setOutsideClick(false);
                                                        }
                                                    }}
                                                >
                                                    <DatePicker
                                                        inputFormat="DD-MMM-YYYY"
                                                        value={startEmailDate}
                                                        className="test"
                                                        onChange={(newValue) => {
                                                            if (newValue && newValue.format() !== "Invalid Date") {
                                                                localStorage.setItem(
                                                                    "emailStartDate",
                                                                    new Date(newValue)
                                                                );
                                                                setEmailStartDate(new Date(newValue));
                                                            } else {
                                                                if (
                                                                    newValue === null ||
                                                                    newValue.format() === "Invalid Date"
                                                                ) {
                                                                    setDisabledButton(true);
                                                                    setOutsideClick(true);
                                                                } else {
                                                                    setDisabledButton(true);
                                                                }
                                                            }
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </ClickAwayListener>

                                                <p className="label">{t("End")}</p>
                                                <ClickAwayListener
                                                    onClickAway={() => {
                                                        if (outsideClick1) {
                                                            setEmailEndDate(new Date(endDate));
                                                            setDisabledButton(false);
                                                            setOutsideClick1(false);
                                                        }
                                                    }}
                                                >
                                                    <DatePicker
                                                        className="test"
                                                        inputFormat="DD-MMM-YYYY"
                                                        value={endEmailDate}
                                                        onChange={(newValue) => {
                                                            if (newValue && newValue.format() !== "Invalid Date") {
                                                                localStorage.setItem(
                                                                    "emailEndDate",
                                                                    new Date(newValue)
                                                                );
                                                                setEmailEndDate(new Date(newValue));
                                                                setDisabledButton(false);
                                                            } else {
                                                                if (
                                                                    newValue === null ||
                                                                    newValue.format() === "Invalid Date"
                                                                ) {
                                                                    setDisabledButton(true);
                                                                    setOutsideClick1(true);
                                                                } else {
                                                                    setDisabledButton(true);
                                                                }
                                                            }
                                                        }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </ClickAwayListener>
                                            </DateRangePickerWrapper>
                                        </LocalizationProvider>
                                    </DatePickerWrapper>
                                </div>
                                <Tooltip title={t("Refresh")}>
                                    <div>
                                        <RefreshBtn disabled={disabledButton} onClick={refreshEmailUI}>
                                            <RefreshBtnIcon color="var(--inner-section-bg)" />
                                            {t("Refresh")}
                                        </RefreshBtn>
                                    </div>
                                </Tooltip>
                                <Tooltip title={t("Export_email_addresses")}>
                                    <div>
                                        <DownloadIcon color="#fff" style={{ cursor: "pointer" }} onClick={downloadToExcel}></DownloadIcon>
                                    </div>
                                </Tooltip>
                            </ActionWrapper>
                            <TableWrapper className="no-pagination" style={{ overflow: "hidden" }}>
                                {getEmailAddressesStatus && getEmailAddressesStatus === "success" ? (
                                    <Box
                                        sx={{
                                            width: "50%",
                                            textAlign: "left",
                                            height: "100%",

                                            "& .super-time-theme--cell": {
                                                fontWeight: "500",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                            },

                                            "& .super-app-theme--cell": {
                                                color: "var(--club-car-gold-bg)",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.negative": {
                                                color: "#FA3C30",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.positive": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.retry": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                            "& .super-app.ready": {
                                                color: "#00A692",
                                                fontWeight: "500",
                                            },
                                        }}
                                    >
                                        <DataGrid
                                            components={{
                                                NoRowsOverlay: () => (
                                                    <Stack
                                                        height="100%"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        {t("No_data")}
                                                    </Stack>
                                                ),
                                            }}
                                            rows={emailrows ? emailrows : []}
                                            columns={emailColumns}
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            hideFooter
                                            getRowId={(emailrows) => emailrows.id}
                                            getRowHeight={() => 30}
                                        />
                                    </Box>
                                ) : (
                                    <CenteredLoader>
                                        <Loader />
                                    </CenteredLoader>
                                )}
                            </TableWrapper>
                        </AccordianDetails>
                    </Accordion>
                </AccordionStyled>
            </Container>
        </>
    );
};

export default ScorecardsTable;
